import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
const translationPrefix = 'clarkwinkelmann-catch-the-fish.forum.fish-image.';
export default class FishImage {
  view(vnode) {
    const src = vnode.attrs.fish.image_url();
    if (src) {
      return m('img.catchthefish-image', {
        alt: extractText(app.translator.trans(translationPrefix + 'alt', {
          name: vnode.attrs.fish.name()
        })),
        src,
        style: {
          animationDuration: vnode.attrs.animationDuration || '10s'
        },
        draggable: false // Without this, browsers somehow drag the image URL across windows instead of the drop data
      });
    }
    return m('.catchthefish-no-image', app.translator.trans(translationPrefix + 'missing'));
  }
}
flarum.reg.add('clarkwinkelmann-catch-the-fish', 'forum/components/FishImage', FishImage);